import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import {
  AllCheckState,
  CertCheckState,
  PartnerListData,
  RecoilStateList,
  TelNumState,
  TermsAgreeState,
  uiVerifyStyle
} from 'src/recoil/common'
import {
  CustomBtn,
  JoinSubmitWrap,
  NoticeFeeText,
} from 'src/styles/styledcomponent/views/join/JoinSubmit'

import PageCalling from 'src/components/common/PageCalling'
import useAPI from 'src/hooks/useAPI'
import { PartnerListType } from 'src/types/type'

const JoinSubmit = (props: any): JSX.Element => {
  const params = useParams()
  const { submit, joinLoading } = props

  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const api = useAPI('requestJoin')
  const { TelType, PhoneNum, CertNum, authKeyValue, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const ResetPhoneNum = useResetRecoilState(TelNumState)
  const ResetCertCheck = useResetRecoilState(CertCheckState)
  const ResetTermsAgree = useResetRecoilState(TermsAgreeState)
  const ResetTerms = useResetRecoilState(AllCheckState)
  const { cashSpace, verifyBtn, cancelBtn } = useRecoilValue(uiVerifyStyle)
  const { mutateAsync: JoinRequest, isLoading } = api.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    TranID: TransId,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData.TermsIdx,
    PCode: params.pcode,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })

  const loading = isLoading || Boolean(joinLoading) || Boolean(submit?.joinLoading)

  return (
    <JoinSubmitWrap>
      <PageCalling active={loading} />
      <CustomBtn
        className='btn_signup'
        {...verifyBtn}
        backgroundColor={PartnerData.FontColor}
        onClick={() => submit.join(JoinRequest)}
        disabled={loading}
      >
        {PartnerData.ButtonMsgAfter}
      </CustomBtn>
      <CustomBtn
        className='btn_cancel'
        {...cancelBtn}
        onClick={() => {
          ResetPhoneNum()
          ResetCertCheck()
          ResetTerms()
          ResetTermsAgree()
        }}
      >
        취소
      </CustomBtn>
      <NoticeFeeText
        cashSpace={cashSpace}
        fontColor={PartnerData.FontColor}
        fontSize={PartnerData.FontSize}
        dangerouslySetInnerHTML={{ __html: PartnerData.NotiContent }}
      />
    </JoinSubmitWrap>
  )
}
export default JoinSubmit
